const PopupsNames = {
  SelectContainerType: 'SelectContainerType',
  ClearProject: 'ClearProject',
  SendProject: 'SendProject',
  ProjectSended: 'ProjectSended',
  MobileDevice: 'MobileDevice',
}

export default PopupsNames
